import { render } from "./login-header.vue?vue&type=template&id=190671d5&scoped=true"
import script from "./login-header.vue?vue&type=script&lang=js"
export * from "./login-header.vue?vue&type=script&lang=js"

import "./login-header.vue?vue&type=style&index=0&id=190671d5&lang=scss&scoped=true"

import exportComponent from "/data/.jenkins/workspace/WEB-samp-webapp-HK/common/temp/node_modules/.pnpm/vue-loader@16.8.3_webpack@4.46.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-190671d5"]])

export default __exports__